
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface BasicInfoFieldsProps {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
}

export const BasicInfoFields = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
}: BasicInfoFieldsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <Label htmlFor="firstName" className="text-black">First Name</Label>
        <Input
          id="firstName"
          value={firstName}
          onChange={(e) => onFirstNameChange(e.target.value)}
          required
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>
      <div>
        <Label htmlFor="lastName" className="text-black">Last Name</Label>
        <Input
          id="lastName"
          value={lastName}
          onChange={(e) => onLastNameChange(e.target.value)}
          required
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>
    </div>
  );
};
